import React, { useEffect, useState } from 'react'

import useTestCustomNotification from '../../hooks/custom_notifications/useTestCustomNotification';
import useSendCustomNotification from '../../hooks/custom_notifications/useSendCustomNotification';

import { INotificationQualifiedUsers } from '../../types/custom_notifications';

import { SVGIcon } from '../wrappers/SVGIcon';

import { Icons } from '../../data/Assets';

interface ITestNotificationModalProps {
    customNotificationId: number;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const TestNotificationModal = (props: ITestNotificationModalProps) => {
    const { customNotificationId, setIsModalOpen } = props;
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [isSending, setIsSending] = useState<boolean>(false);
    const [apiError, setApiError] = useState<string | null>(null);
    const [notificationQualificationResult, setNotificationQualificationResult] = useState<INotificationQualifiedUsers[]>([]);
    const [content, setContent] = React.useState<{ id: number, email: string; }[]>([]);

    const { mutate: testCustomNotification } = useTestCustomNotification();
    const { mutate: sendCustomNotification } = useSendCustomNotification();

    const onAcceptModal = () => {
        setIsSending(true);
        sendCustomNotification({
            data: {
                id: customNotificationId,
                qualifiedUsers: notificationQualificationResult,
            },
            setIsProcessing,
            setApiError,
        });
    };

    const onCloseModal = () => {
        setIsModalOpen(false);
        setNotificationQualificationResult([]);
        setContent([]);
        setApiError(null);
    }

    useEffect(() => {
        if (isSending && !isProcessing) {
            setIsSending(false);
            setIsModalOpen(false);
            setNotificationQualificationResult([]);
            setContent([]);
            setApiError(null);
        };
    }, [isSending, isProcessing]); // eslint-disable-line

    useEffect(() => {
        if (notificationQualificationResult.length > 0) {
            const content = notificationQualificationResult.map((item) => {
                const userEmail = item.email;
                const userId: number = item.id;
                return {
                    id: userId,
                    email: userEmail,
                };
            });

            setContent(content);
        }
    }, [notificationQualificationResult]); // eslint-disable-line

    useEffect(() => {
        if (customNotificationId) {
            testCustomNotification({
                data: customNotificationId,
                setNotificationQualificationResult,
                setIsProcessing,
                setApiError,
            });
        }
    }, [customNotificationId]); // eslint-disable-line

    return (
        <div className="imm_admin__custom_modal">
            <div className="custom_modal__container">
                <div className="custom_modal__header">
                    <h4>Send Notification</h4>
                    <br />
                    <p>Qualified Users:</p>
                </div>
                <ul className='custom_modal__content_list'>
                    {isProcessing && <li><span>Testing in progress...</span></li>}
                    {apiError && <li className='color_error'>{apiError}</li>}
                    {!isProcessing && !apiError && content.length === 0 && <li><span>No results found</span></li>}

                    {content.map((item, index) => (
                        <li key={index}>
                            <span className=''><SVGIcon src={Icons.PointFill} />&nbsp;{item.email}</span>
                        </li>
                    ))}
                </ul>
                {content.length > 0 && <div className='custom_modal__warning'>
                    <br />
                    <p className='color_error'>*This action will send this notification to the qualified users. Are you sure you want to proceed?</p>
                </div>}
                <div className="custom_modal__actions">
                    {content.length > 0 && (
                        <>
                            <button disabled={isProcessing} className="modal__decline_btn" onClick={onCloseModal}>
                                Cancel
                            </button>
                            <button disabled={isProcessing} className="modal__accept_btn" onClick={onAcceptModal}>
                                {isProcessing ? 'Sending...' : 'Send'}
                            </button>
                        </>
                    )}

                    {content.length === 0 && (
                        <button disabled={isProcessing} className="modal__accept_btn" onClick={onCloseModal}>
                            Okay
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default TestNotificationModal;